import { Autoplay, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { CustomerStoryTestimonialProps } from "./index";

export const MobileCustomerStoryTestimonial = ({ testimonials }: { testimonials: CustomerStoryTestimonialProps[] }) => {
  return (
    <div className="md:hidden p-1 col-span-2 col-start-2 row-start-2 bg-transparent relative  rounded-[12px]">
      {/* Custom pagination classes emulating desktop pagination from swiper-overrides.css */}
      <Swiper
        pagination={{
          clickable: true,
          type: 'bullets',
          el: '.swiper-pagination-white',
          bulletClass: 'swiper-pagination-bullet-white',
          bulletActiveClass: 'swiper-pagination-bullet-white-active',
        }}
        slidesPerView={1.1}
        centeredSlides={true}
        spaceBetween={20}
        autoplay={{
          delay: 5000,
          disableOnInteraction: true,
        }}
        loop={true}
        modules={[Autoplay, Pagination]}
      >
        {testimonials.map((testimonial) => (
          <SwiperSlide key={`customer-story-testimonial-${testimonial.author}`}>
            <div className="py-4 flex flex-col justify-center items-center text-center">
              <div className="max-h-10 mx-auto mb-3">{testimonial.logo}</div>
              <p className="mb-3 text-h4 font-serif font-500 text-blue-900">{testimonial.quote}</p>
              <div className="flex flex-col">
                <span className="text-p2 mb-[6px] font-400 text-blue-1000">{testimonial.author}</span>
                <span className="text-micro2 text-blue-1000 uppercase">{testimonial.title}</span>
              </div>
            </div>
          </SwiperSlide>
        ))}
        <div className="swiper-pagination-white" />
      </Swiper>
    </div>
  );
};
